import React from "react";
import classNames from "classnames";
import styles from "./Loader.module.scss";

interface Props {
    inline?: boolean;
    delayed?: boolean;
    className?: string;
}

export const Loader: React.FC<Props> = ({
    inline = false,
    delayed = false,
    className,
}) => (
    <div
        className={classNames(styles.loader, className, {
            [styles.loaderInline]: inline,
            [styles.loaderDelayed]: delayed,
        })}
        role="status"
        aria-label="Loading"
    >
        <svg
            className={classNames(styles.loaderSpinner, {
                [styles.loaderSpinnerSm]: inline,
            })}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="1"
                strokeDasharray="50 30"
                strokeLinecap="round"
            />
        </svg>
    </div>
);
